export default {"src":"/betting-resources/_next/static/media/pinnacle-logo.9bfafc84.svg","height":24,"width":98,"blurWidth":0,"blurHeight":0};